import { fabric } from "fabric";

import Navigation from "./navigation/navigation";
import Ruler from "./navigation/ruler";
import CutZone from "./cutzone.js";
import Persistent from "./persistent.js";
import History from "./history";
import Printplate from "./printplate";
import Hotkeys from "./hotkeys";
import Collage from "./collage";

import Layers from "./layers.js";

import { throttle } from "underscore";

const rotationIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkARoOHx5+DnOIAAAB90lEQVRIx6WUz4tNYRjHv+dozOQaGT9KY2Yjck2EO4shm9lRsxgLRWbpL5Bs7BUrzU5JZCHUCJP8iLIQmkJWQ0Zy6RLjRwyu3Hs/Fve9zznnuve8J76b8/Z8fzzv+5z3nEAtQKBB7dQ2rVC/pNd6p7u6pEcB8oOQMWZohRn2Evrs63lMGh4ykGbfwRd8+Mpo3BPE7Lt0XvEtTmtKJUm9GlI+Vq9qdzDxd/cC361LhVOsTbB5TlM1fo7NzfYuXhpdYkvLA26lZJoXdCbJg0a9oq/tjPopmu5AnFjEJ1f+wabUt1Tgp1N+pDsqj1nuYe89OWraPVHxgvVf7A3osT2ci4qNA1z22SWJSaeelaRQIqcex93JEmCqpSyQQkkrjXqTKSBS9dYDFlqhnClgzla5esC3eGIGLLfV+3pAURVXyGcKKLhnRR8ac33i5lr0fu8i4LlT35Pkvr4bkqSaHijn7T+i1W51M0rdQJkTrPHvnk6mXf8q6+LEshTTcOOCE3DSLvLFTPNiFRPApCTRwXGz/2Kj39zNEcpQD2CQ+7Ef2yGfOWQfb03+jNvUYvYrzEu3DyW6NeMaXWnmPs4kuiVRY5z56d0HuN7WPsVwttmP8LTJOstZtmcyu4gO9vPZ7Lc8Q2sTsoRxfjde4z+CPFf/K0CSGOVYe/YPjW5I6lcsty0AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDEtMjZUMTQ6MzE6MzArMDA6MDD5yp61AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTAxLTI2VDE0OjMxOjMwKzAwOjAwiJcmCQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=";
const rotationImage = new Image();
rotationImage.src = rotationIcon;

//FIXME: getrid of monkey patching
export default class DeskpadEditor {
  constructor(id, width, height) {
    this.initFabricDefaults();
    const canvas = new fabric.Canvas(id);
    canvas.DPE = {};
    this.canvas = canvas;
    window.c = canvas;
    canvas.setWidth(width);
    canvas.setHeight(height);
    canvas.backgroundColor = "#EEE";
    canvas.defaultCursor = "pointer";
    canvas.snapAngle = 45;
    canvas.snapThreshold = 10;
    canvas.preserveObjectStacking = true;
    canvas.selection = false;

    canvas.settings = {
      minWidth: 5,
      minHeight: 5,
      maxWidth: 350,
      maxHeight: 350,
      minDPI: 60,
      isDynamicSize: true
    };

    const { DPE } = canvas;
    DPE.navigation = new Navigation(canvas);
    DPE.cutZone = new CutZone(canvas, 700, 500);
    DPE.layers = new Layers(canvas);
    DPE.persistent = new Persistent(canvas);
    DPE.history = new History(canvas);
    DPE.printplate = new Printplate(canvas);
    DPE.hotkeys = new Hotkeys(canvas).enable();
    DPE.collage = new Collage(canvas);
    DPE.ruler = this.initRuller();
    this.initLoader();
    this.initDPILimiter();
    this.initControlsIcon();
    DPE.cutZone.fitCutZone();
  }

  initFabricDefaults() {
    fabric.Object.prototype.strokeWidth = 0;
    fabric.Object.prototype.snapAngle = 45;
    fabric.Object.prototype.snapThreshold = 5;
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.globalCompositeOperation = "source-atop";
    fabric.Path.prototype.globalCompositeOperation = "source-over";
    fabric.Rect.prototype.globalCompositeOperation = "source-over";
    fabric.Line.prototype.globalCompositeOperation = "source-over";

    fabric.IText.prototype.editingBorderColor = "#4A90E2";

    fabric.Line.prototype.getObjectById = function(id) {
      return this.getObjects().find(obj => obj.id === id);
    };

    fabric.Canvas.prototype.hasCollage = function() {
      return !!this.getObjects().find(obj => obj.mask);
    };

    fabric.maxCacheSideLimit = 1000;
    fabric.perfLimitSizeTotal = 409710;
    fabric.Object.NUM_FRACTION_DIGITS = 17;

    fabric.Object.prototype.borderColor = "#aa00aa";
    fabric.Object.prototype.cornerColor = "#aa00aa";
    fabric.Object.prototype.cornerStrokeColor = "#aa00aa";

    if (window.innerWidth < 786) {
      fabric.Object.prototype.cornerSize = 18;
    }

    /**
     * Creates an instance of fabric.Image from its object representation
     * @static
     * @param {Object} object Object to create an instance from
     * @param {Function} callback Callback to invoke when an image instance is created
     */
    fabric.Image.fromObject = function(object, callback) {
      fabric.util.loadImage(
        object.src,
        function(img, error) {
          if (error) {
            callback && callback(null, error);
            return;
          }
          fabric.Image.prototype._initFilters.call(
            object,
            object.filters,
            function(filters) {
              object.filters = filters || [];
              fabric.Image.prototype._initFilters.call(
                object,
                [object.resizeFilter],
                function(resizeFilters) {
                  object.resizeFilter = resizeFilters[0];
                  var elWidth = img.naturalWidth || img.width;
                  var elHeight = img.naturalHeight || img.height;
                  var scaleX = ((object.scaleX || 1) * object.width) / elWidth;
                  var scaleY =
                    ((object.scaleY || 1) * object.height) / elHeight;
                  object.width = elWidth;
                  object.height = elHeight;
                  object.scaleX = scaleX;
                  object.scaleY = scaleY;
                  var image = new fabric.Image(img, object);
                  callback(image);
                }
              );
            }
          );
        },
        null,
        object.crossOrigin
      );
    };
  }

  initRuller() {
    const { canvas } = this;
    const rul = new Ruler(document.querySelector(".canvas-container"));
    rul.setPos(0, 0);
    canvas.on(
      "canvas:viewport",
      throttle(() => {
        const offset = 5;
        const vp = canvas.vptCoords;
        const zoom = canvas.getZoom();
        const x = (vp.tl.x - offset) * zoom;
        const y = (vp.tl.y - offset) * zoom;
        rul.setPos(x, y);
      }, 16)
    );
    canvas.on(
      "canvas:zoom",
      throttle(() => {
        const zoom = canvas.getZoom();
        rul.setZoom(1 / zoom);
      }, 16)
    );
    return rul;
  }

  initDPILimiter() {
    const { canvas } = this;
    const orderItemId = new URLSearchParams(window.location.search).get("orderItem");
    const orderId = new URLSearchParams(window.location.search).get("orderId");
    canvas.on("object:scaling", e => {
      if (window.isDeskpadAdmin) {
        return;
      }
      if (orderItemId || orderId) {
        return;
      }
      const obj = e.target;
      if (obj.isVector) return;
      if (obj.type !== "image") return;
      const { minDPI } = canvas.settings;
      const mmInInch = 1 / 25.4;
      if (!obj.lastGoodTop) {
        obj.lastGoodTop = obj.top;
      }
      if (!obj.lastGoodLeft) {
        obj.lastGoodLeft = obj.left;
      }
      // const widthInInch = obj.width * obj.scaleX * mmInInch;
      // const DPI = actualPixelWidth / widthInInch;
      const actualPixelWidth = obj.size.width;
      const maxScaleX = actualPixelWidth / (minDPI * obj.width * mmInInch);
      if (obj.scaleX > maxScaleX) {
        canvas.fire("object:scaleLimit");
        obj.scaleX = maxScaleX;
        obj.left = obj.lastGoodLeft;
        obj.top = obj.lastGoodTop;
      }
      if (obj.scaleY > maxScaleX) {
        obj.scaleY = maxScaleX;
        obj.left = obj.lastGoodLeft;
        obj.top = obj.lastGoodTop;
      }

      obj.lastGoodTop = obj.top;
      obj.lastGoodLeft = obj.left;
    });
    canvas.on("object:moving", e => {
      const obj = e.target;
      if (obj.type !== "image") return;
      obj.lastGoodTop = obj.top;
      obj.lastGoodLeft = obj.left;
    });
  }

  initLoader() {
    const { canvas } = this;
    const { DPE } = canvas;
    canvas.on("canvas:loaded", e => {
      DPE.cutZone = new CutZone(
        canvas,
        canvas.cutW,
        canvas.cutH,
        canvas.cutRadius
      );
      DPE.cutZone.fitCutZone();
      canvas.loaded = true;
    });
  }

  initControlsIcon() {
    const { canvas } = this;
    var _original = fabric.Object.prototype._drawControl;
    fabric.Object.prototype._drawControl = function(
      control,
      ctx,
      methodName,
      left,
      top
    ) {
      var size = this.cornerSize;
      const borderColor = this.borderColor;
      if (
        this.canvas.hasControlCallback &&
        this.canvas.hasControlCallback[control]
      ) {
        this.canvas.controlCallback[control](ctx, left, top, size, borderColor);
      } else {
        _original.call(this, control, ctx, methodName, left, top);
      }
    };
    canvas.hasControlCallback = {
      mtr: true
    };

    canvas.controlCallback = {
      mtr: function mtrControlCallback(ctx, left, top, size, borderColor) {
        const x = left - 10 + size / 2;
        const y = top - 10 + size / 2;
        ctx.fillStyle = borderColor;
        // ctx.fillRect(x, y, 20, 20);
        ctx.beginPath();
        ctx.arc(x + 10, y + 10, 12, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.drawImage(rotationImage, x, y, 20, 20);
      }
    };
  }
}
